import Position from './Position.vue';
import AddSaleFnsMixin from '../AddSaleFnsMixin';

export default {
  name: 'AddSaleFns',
  mixins: [AddSaleFnsMixin],
  components: { Position },
  methods: {
    addPosition() {
      this.form.positions.push({
        article: null,
        product_id: null,
      });
    },
    deletePosition(idx) {
      this.positions.splice(idx, 1);
    },
    /**
     * Метод добавления новой продажи.
     */
    onSubmit(is_draft = false) {
      this.submitIsProcessing = true;
      const app = this;
      let restURL = 'sales/api/sale-fns/create';

      const sale = {
        register_type: 'web',
        ...this.form,
        is_draft,
        profile_id: this.user.profile_id,
        action_id: this.action_id,
      };

      if (app.saleID !== 'null') {
        restURL = 'sales/api/sale-fns/update';
        sale.sale_id = app.sale.id;
        sale.action_id = app.sale.action_id;
        sale.register_type = 'web';
      }

      app.$store.getters.axl.post(restURL, sale)
        .then(() => {
          this.$store.dispatch('sales/GetSales', {
            profile_id: this.$store.state.user.profile_id,
          });
          app.$router.push('/sales/purchase');
          app.$store.dispatch('ShowInfo', 'Монтаж отправлен на проверку');
        })
        .catch((error) => {
          app.$store.dispatch('HandleError', error);
        }).finally(() => {
          this.submitIsProcessing = false;
        });
    },
  },
  mounted() {
    if (this.saleID !== 'null' || this.saleID) {
      this.setDataPreload();
    } else {
      this.addPosition();
    }
  },
};
